import React, { useContext, useState } from 'react';
import { AppleLogo, EyeClosed, EyeOpen, GooglePlay } from '../../assets/icons/IconComponents';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie'
import createAxiosInstance, { setAuthToken } from '../axios/axiosCustom'
import { useTranslation } from 'react-i18next';
import { Store } from '../utils/Store';
import { OAuthProvider, signInWithPopup } from 'firebase/auth';
import { appleProvider, auth, googleProvider } from '../utils/auth';



function Login({callback}) {
  const [username, setUsername] = useState('')
  const [password, setEnteredPass] = useState('')
  const [showHideButton, setShowHideButton] = useState('show')
  const [buttonType, setButtonType] = useState('password')
  
  const navigate = useNavigate()
  const { t } = useTranslation()

  const { dispatch } = useContext(Store)
  
  const showPassword = () => {
    setShowHideButton(buttonType === 'password' ? 'hide' : 'show')
    setButtonType(buttonType === 'password' ? 'text' : 'password')
  }

  const onLogin = async (e) => {
    let errMsg = document.querySelector('.err-msg')
    try {
      toggleLoading(true)
      errMsg.setAttribute('hidden', true)
      const axiosCustom = await createAxiosInstance()
      const resp = await axiosCustom.post('/log_in', {
        username,
        password,
        loginWith: 'feenta'
      })

      let data = resp?.data
      // console.warn(resp)
      if(data){
        Cookies.set('refreshToken', JSON.stringify(data.refreshToken))
        const accessToken = 'Bearer '.concat(data.accessToken)
        const user = await axiosCustom.get('/getUser', { headers: { authorization: accessToken }})
        
        dispatch({ type: 'ACCESS_TOKEN', payload: accessToken })
        dispatch({ type: 'USER_LOGIN', payload: user.data })
        setAuthToken(accessToken)
        
        callback({succ: true})
        
      } else {
        errMsg.removeAttribute('hidden')
        errMsg.innerText = 'Something went worng'
      }
      toggleLoading(false)
      
    } catch(err){
      console.warn('err', err)
      errMsg.removeAttribute('hidden')
      errMsg.innerText = t(err?.response?.data?.transl_key) || 'Something went wrong'
      toggleLoading(false)
    }
  }

  const onLoginGoogle = async () => {
    let errMsg = document.querySelector('.err-msg')

    try {
      const result = await signInWithPopup(auth, googleProvider)
      // console.warn("result:", result)
      const loggedInUser = result.user

      const axiosCustom = await createAxiosInstance()
      const resp = await axiosCustom.post('/log_in', {
        loginWith: 'google',
        oauthToken: loggedInUser.accessToken
      })

      let data = resp?.data
      if(data){
        Cookies.set('refreshToken', JSON.stringify(data.refreshToken))
        const accessToken = 'Bearer '.concat(data.accessToken)
        const user = await axiosCustom.get('/getUser', { headers: { authorization: accessToken }})
        
        dispatch({ type: 'ACCESS_TOKEN', payload: accessToken })
        dispatch({ type: 'USER_LOGIN', payload: user.data })
        setAuthToken(accessToken)
        
        callback({succ: true})
        
      } else {
        errMsg.removeAttribute('hidden')
        errMsg.innerText = 'Something went worng'
      }

    } catch (err) {
      console.error("err", err);
      errMsg.removeAttribute('hidden')
      errMsg.innerText = t(err?.response?.data?.transl_key) || 'Something went wrong'
    }
  }
  
  const onLoginApple = async () => {
    let errMsg = document.querySelector('.err-msg')

    try {
      const result = await signInWithPopup(auth, appleProvider);
      const user = result.user
      
      const credential = OAuthProvider.credentialFromResult(result)
      const appleIdToken = credential.idToken
      // console.warn("user", user)
      // console.warn("credential", credential)

      const axiosCustom = await createAxiosInstance()
      const resp = await axiosCustom.post('/log_in', {
        loginWith: 'apple',
        oauthToken: appleIdToken
      })

      let data = resp?.data
      if(data){
        Cookies.set('refreshToken', JSON.stringify(data.refreshToken))
        const accessToken = 'Bearer '.concat(data.accessToken)
        const user = await axiosCustom.get('/getUser', { headers: { authorization: accessToken }})
        
        dispatch({ type: 'ACCESS_TOKEN', payload: accessToken })
        dispatch({ type: 'USER_LOGIN', payload: user.data })
        setAuthToken(accessToken)
        
        callback({succ: true})
        
      } else {
        errMsg.removeAttribute('hidden')
        errMsg.innerText = 'Something went worng'
      }
      
    } catch (err) {
      errMsg.removeAttribute('hidden')
      errMsg.innerText = t(err?.response?.data?.transl_key) || 'Something went wrong'
    }
  }
  
  const toggleLoading = (code) => {
    let submitBt = document.querySelector('.log_in')
    let spinner = document.querySelector('.spinner')

    if(code) {
      submitBt.classList.add('bt-loading')
      submitBt.setAttribute('disabled', true)
      spinner.removeAttribute('hidden')
    } else {
      submitBt.classList.remove('bt-loading')
      submitBt.removeAttribute('disabled')
      spinner.setAttribute('hidden', true)
    }
  }

  return (
    <>
    <div className="modal-header">
      <div className="fx fx-col fxac">
        <h2>{t('login_title')}</h2>
        <h4 style={{opacity:0.6, marginTop:0}}>{t('login_info')}</h4>
        <span className="err-msg" style={{color:'#fe5959'}} hidden></span>
      </div>
    </div>
    <div className="content-list">
      <div className="feenta-content">
        <input type="text" autoComplete="off" name="username" id="username" placeholder={'Username or email'} onChange={(e) => setUsername(e.target.value)} />
        <div className="div-pass">
          <input type={buttonType} name="password" autoComplete="off" id="password" placeholder={'Password'} onChange={(e) => setEnteredPass(e.target.value)} />
          <span className="show-pass cust-icon" onClick={showPassword} value={showHideButton} >{buttonType !== 'password' ? <EyeOpen /> : <EyeClosed />}</span>
        </div>
        <button className="bt login-bt log_in" onClick={onLogin}>{t('login')} <span className="spinner" hidden></span></button>
      </div>
      
      <span className="line-text">{t('or_login_with')}</span>
      
      <div className="fx fx-col fxac">
        <button className="bt google-bt icon-bt" onClick={onLoginGoogle}> <GooglePlay /> {t('google')}</button>
        <button className="bt apple-bt icon-bt" onClick={onLoginApple}> <AppleLogo /> {t('apple')}</button>
      </div>
    </div>        
    <div className="modal-btns">
      <button className="bt bt-cancel" onClick={() => callback({closeModal: true})}>{t('cancel')}</button>
    </div>
    </>
  );
}

export default Login
